// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-wrap[data-v-55567606]{position:fixed;top:0;left:50%;transform:translateX(-50%);z-index:1501;width:100%;max-width:800px;padding:0 20px}.password-reset[data-v-55567606]{display:flex;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
